<div class="flex flex-col gap-2">
  <label class="flex flex-col gap-1">
    <span class="text-sm font-semibold text-neutral-700">{{ "guaranteeV2.label.partner" | translate }}</span>

    <guarantees-partner-picker
      [service]="service()"
      [selected]="partner()"
      (chosen)="choosePartner($event)"
    ></guarantees-partner-picker>
  </label>

  <label class="flex flex-col gap-1">
    <span class="flex items-center gap-2">
      <span class="min-w-0 flex-1 text-sm font-semibold text-neutral-700">{{ "guaranteeV2.label.location" | translate }}</span>

      <!-- One set of branches, two ways of recognising it: by its address, or by where it stands. -->
      <span [class]="segmentedGroup">
        @for (option of views; track option.id) {
          <button
            guaranteesToggle
            [pressed]="view() === option.id"
            size="sm"
            shape="segment"
            type="button"
            (click)="setView(option.id)"
          >
            <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">{{ option.icon }}</mat-icon>
            {{ option.labelKey | translate }}
          </button>
        }
      </span>
    </span>

    <guarantees-search-field
      cdkOverlayOrigin
      #locationOrigin="cdkOverlayOrigin"
      icon="location_on"
      name="locationSearch"
      [disabled]="!partnerChosen()"
      [ariaLabel]="'guaranteeV2.label.location' | translate"
      [placeholder]="locationDisplay() || ((partnerChosen() ? 'guaranteeV2.message.searchLocation' : 'guaranteeV2.message.choosePartnerFirst') | translate)"
      [filled]="!!locationDisplay()"
      [value]="locationTerm()"
      [loading]="loadingLocations()"
      (valueChange)="typeLocation($event)"
      (opened)="openLocationList()"
      (closed)="closeLocation()"
    ></guarantees-search-field>
  </label>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="locationOrigin"
    [cdkConnectedOverlayOpen]="listOpen()"
    [cdkConnectedOverlayWidth]="panelWidth()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (overlayOutsideClick)="close()"
  >
    <guarantees-option-list
      [empty]="locations().length === 0 && !loadingLocations()"
      [emptyMessage]="'guaranteeV2.message.noLocations' | translate"
    >
      @for (option of locations(); track option.id) {
        <li>
          <button
            guaranteesOption
            type="button"
            [class]="option.id === location()?.id ? 'bg-primary-50' : ''"
            (click)="chooseLocation(option)"
          >
            @if (namesBranch(option)) {
              <span class="shrink-0 font-semibold text-neutral-700">{{ option.name }}</span>
            }
            <span class="min-w-0 flex-1 truncate text-neutral-600">{{ option.address }}</span>
          </button>
        </li>
      }
    </guarantees-option-list>
  </ng-template>

  @if (view() === "map") {
    @if (!partnerChosen()) {
      <guarantees-callout icon="info">
        {{ "guaranteeV2.message.choosePartnerFirst" | translate }}
      </guarantees-callout>
    } @else if (mapEmpty()) {
      <guarantees-callout
        tone="warning"
        icon="wrong_location"
      >
        {{ "guaranteeV2.message.noMappedLocations" | translate }}
      </guarantees-callout>
    } @else {
      <guarantees-location-map
        class="block h-64 w-full"
        [markers]="markers()"
        [selectedId]="location()?.id"
        (selected)="chooseFromMap($event)"
      ></guarantees-location-map>
    }
  }

  @if (withDoctor()) {
    <label class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-neutral-700">{{ "guaranteeV2.label.doctor" | translate }}</span>

      <input
        guaranteesControl
        class="w-full"
        name="doctorName"
        type="text"
        autocomplete="off"
        [disabled]="!partnerChosen()"
        [attr.aria-label]="'guaranteeV2.label.doctor' | translate"
        [placeholder]="(partnerChosen() ? 'guaranteeV2.message.doctorNamePlaceholder' : 'guaranteeV2.message.choosePartnerFirst') | translate"
        [value]="doctorName()"
        (input)="typeDoctor($any($event.target).value)"
      />
    </label>
  }
</div>
